import { CircularProgress } from "@suraasa/placebo-ui"
import { ToolType } from "api/resources/aiTools/types"
import ContentActions from "features/AItools/components/Generator/GenerationOutput/Export/ContentActions"
import Heading from "features/AItools/components/Heading"
import { getToolName } from "features/AItools/helper"

import RubricOutput from "../GenerationOutput/RubricsOutput"
import ProForm from "./ProForm"
import { useRubrics } from "./useRubrics"

const RubricsGenerator = ({
  toggleHistorySideBar,
}: {
  toggleHistorySideBar: (state: boolean) => void
}) => {
  const {
    currentResponseId,
    setCurrentResponseId,
    onBack,
    pageLoading,
    promptDataId,
    ...rubricsContext
  } = useRubrics()

  if (promptDataId && pageLoading) {
    return (
      <div className="grid place-items-center p-4">
        <CircularProgress />
      </div>
    )
  }

  if (currentResponseId) {
    return (
      <>
        <ContentActions
          onBack={onBack}
          currentResponseId={currentResponseId}
          toolType={ToolType.rubrics}
          title={rubricsContext.overviewData?.title}
          toggleHistorySideBar={toggleHistorySideBar}
          hideExportOutputButton={
            rubricsContext.isError ||
            rubricsContext.isLoading ||
            currentResponseId === undefined
          }
        />

        <RubricOutput
          {...rubricsContext}
          currentResponseId={currentResponseId}
          setCurrentResponseId={setCurrentResponseId}
          onBack={onBack}
        />
      </>
    )
  }

  return (
    <>
      <Heading
        title={`${getToolName(ToolType.rubrics)} Generator`}
        subtitle="Simplify assessment creation with the AI Rubrics Generator, enabling precise assignment evaluation."
        toggleHistorySideBar={toggleHistorySideBar}
      />
      {/* <TogglePro
        isPro={enableProMode}
        onChange={state => setEnableProMode(state)}
        className="mb-2"
      /> */}
      <ProForm {...rubricsContext} />
      {/* {enableProMode ? (
        <ProForm {...rubricsContext} />
      ) : (
        <BasicForm {...rubricsContext} />
      )} */}
    </>
  )
}

export default RubricsGenerator
